import type { ClubCountryCodes, MatchAndClubCountryCode, UserGender } from "@teamz/common";

import { clubCountryCodes } from "@teamz/common";
import { useTranslation } from "react-i18next";

import { Select, SelectContent, SelectGroup, SelectItem, SelectSeparator, SelectTrigger, SelectValue } from "@/components/ui/select";
import { RootField, TextField } from "@/components/ui/text-field";
import { useTranslationUtils } from "@/hooks/use-translation-utils";

export function FilterBarClubList(
  {
    search,
    country,
    gender,
    setSearch,
    setCountryFilter,
    setGenderFilter,
  }:
  {
    search?: string;
    country?: MatchAndClubCountryCode[number] | ClubCountryCodes[number];
    gender?: UserGender[number];
    setSearch: (search: string) => void;
    setCountryFilter?: (country: MatchAndClubCountryCode | ClubCountryCodes) => void;
    setGenderFilter?: (gender: UserGender) => void;
  },
) {
  const { getCountryName } = useTranslationUtils();
  const { t } = useTranslation(["common"]);

  return (
    <div>
      <div className="grid grid-cols-1 items-center gap-y-2 bg-neutral-700 p-3 md:grid-cols-4 md:gap-y-0 md:rounded-t-xl md:px-4 md:py-5">
        <h1 className="col-span-1 shrink-0 text-nowrap text-center text-lg font-medium text-white md:text-start md:text-xl">
          {t("common:clubs-list")}
        </h1>

        <RootField className="col-span-2 flex-1">
          <TextField
            clearable
            onClear={() => {
              setSearch("");
            }}
            value={search}
            placeholder={t("common:search-club")}
            className="border-0 text-white"
            onChange={event => setSearch(event.target.value)}
          />
        </RootField>
      </div>

      { setCountryFilter && setGenderFilter && (
        <div className="flex flex-col gap-2 bg-neutral-600 p-3 md:rounded-b-xl">
          <div className="flex flex-col gap-2 md:flex-row md:items-center md:justify-between md:gap-4">
            <div className="flex w-full items-center gap-2">
              <Select onValueChange={value => setCountryFilter(value as ClubCountryCodes)} value={country}>
                <SelectTrigger className="border-0 bg-neutral-700 text-white md:max-w-[215px]">
                  <SelectValue placeholder={t("common:country")} className="text-white" />
                </SelectTrigger>
                <SelectContent>
                  <SelectGroup>
                    {/* @ts-expect-error Error type on null value */}
                    <SelectItem value={null} className="font-semibold">
                      {t("common:see-all")}
                    </SelectItem>
                    <SelectSeparator />
                    {clubCountryCodes.map(country => (
                      <SelectItem key={country} value={country}>
                        {getCountryName(country.toUpperCase() as ClubCountryCodes)}
                      </SelectItem>
                    ))}
                  </SelectGroup>
                </SelectContent>
              </Select>

              <Select onValueChange={value => setGenderFilter(value as UserGender)} value={gender}>
                <SelectTrigger className="border-0 bg-neutral-700 text-white md:max-w-[215px]">
                  <SelectValue placeholder={t("common:gender")} />
                </SelectTrigger>
                <SelectContent>
                  <SelectGroup>
                    {/* @ts-expect-error Error type on null value */}
                    <SelectItem value={null} className="font-semibold">
                      {t("common:see-all")}
                    </SelectItem>
                    <SelectSeparator />
                    <SelectItem value="male">{t("common:man")}</SelectItem>
                    <SelectItem value="female">{t("common:woman")}</SelectItem>
                  </SelectGroup>
                </SelectContent>
              </Select>

            </div>
          </div>
        </div>
      )}
    </div>
  );
}
